<template>
  <b-container fluid>
    <b-row>
      <b-col lg="12" class="allCardList">
        <iq-card>
          <template v-slot:headerTitle v-if="!propOpenedInModal">
            <div class="row card-title">
              <div class="col-sm-6">
                  <span class="pe-3">{{ cvCardTitle }}:&nbsp;{{ vmQuizFormData.app_name }}</span>
              </div>
              <div class="col-sm-6">
                <span class="btn_in_header">
                  <b-button variant="primary mb-2 mr-2" @click="goToEventDashboard">Dashboard</b-button>
                  <b-button variant="primary mb-2 mr-2" @click="quizDetail(vmQuizFormData.app_id)">View {{vmQuizFormData.app_type == QuizType.COMPETITION ? 'Challenge' : 'Quiz'}}</b-button>
                  <b-button variant="primary mb-2 mr-2" @click="startQuiz(vmQuizFormData.app_id, 'QUIZ_LAYOUT')">Start Quiz</b-button>
                  <b-button variant="primary mb-2 mr-2" @click="quizBankList(vmQuizFormData.app_id)">Question Bank</b-button>
                </span>
              </div>
            </div>
          </template>
          <template v-slot:body>
            <form action="#" v-if="vmQuizFormData && Object.keys(vmQuizFormData).length > 0">
              <div class="form-row">
                <div class="mt-4">
                    <h4 class="mb-3">
                      {{ cvPBACoverPic }} : {{ imageSize }}
                    </h4>
                    <div class="form-group row align-items-center">
                      <div class="col-md-12">
                        <div class="profile-img-edit border" style="height: 200px; width: 300px;">
                          <img v-if="vmCoverPic" :src="vmCoverPic" alt="profile-pic " style="height: 100%; width: 100%; object-fit: cover; overflow: hidden;" />
                          <i v-else class="fas fa-calendar d-flex justify-content-center align-items-center" style="font-size: 5rem; height:100%; color: #c1c1c1;"></i>
                          <label class="p-image">
                            <i class="ri-pencil-line upload-button" style="cursor: pointer;"></i>
                            <input class="file-upload" type="file" required accept="image/png,image/jpeg,image/jpg" id="fileInput1" style="display: block; position: absolute; opacity: 0; left: 0; top: 0; pointer-events: none;" @change="openImageDialog($event, 'Cover Pic')" />
                          </label>
                        </div>
                      </div>
                      <span class="text-danger" ref="coverPicError"></span>
                    </div>
                </div>
                <div class="col-md-12 mb-3">
                  <label for="validationexam_name">{{ cvExamNameLabel }}</label>
                    <ValidationProvider
                    name="Quiz Name"
                    rules="required"
                    v-slot="{ errors }">
                    <input v-model.trim="vmQuizFormData.app_name" type="text" class="form-control" required />
                    <span class="text-danger"> {{ errors[0] }} </span>
                    </ValidationProvider>
                </div>

                <!-- App name alias-->
                <div class="col-md-12 mb-3">
                  <label for="app_name_alias">{{ cvAliasNamelabel }}</label>
                  <ValidationProvider name="App Name Alias" rules="required"  v-slot="{ errors }">
                    <input id="app_name_alias" v-model.trim="vmQuizFormData.app_name_alias" type="text" class="form-control" required />
                    <span class="text-danger"> {{ errors[0] }} </span>
                  </ValidationProvider>
                </div><!-- App name alias-->

                <div class="col-md-12 mb-3">
                  <span v-if="vmQuizFormData.chained_app_id">
                    <label>App chained to:&nbsp;</label>
                    <span class="primary-color pointer" @click="openChainedAppInNewTab(vmQuizFormData.chained_app_id)">
                      <b>{{ vmQuizFormData.chained_app_name}}</b>&nbsp;&nbsp;<small>({{vmQuizFormData.chained_app_id}})</small>
                    </span>
                  </span>
                  <span v-else class="primary-color">
                    Choose app(s) from the dropdown below for chaining
                  </span>

                  <!-- Multiselect component -->
                  <multiselect
                    :value="getSelectedAppObject"
                    @input="onSelectApp"
                    :options="chainableApps"
                    :multiple="false"
                    :close-on-select="true"
                    :clear-on-select="true"
                    :preserve-search="true"
                    placeholder="Pick an app"
                    label="app_name"
                    track-by="app_id"
                    >
                    <template #option="props">
                      <span>{{ props.option?.app_name || '' }}</span>
                    </template>
                    <template #selection="props">
                      <span>{{ props.option?.app_name || '' }}</span>
                    </template>
                  </multiselect>
                  <small class="primary-color">
                    Selected app will be chained to this app on save
                  </small>
                </div>
                <div class="col-md-12 mb-3">
                  <label for="validationexam_name">{{ cvExamTypeLabel }} - <b>{{ vmQuizFormData.app_type }}</b></label>
                  <!--
                  <ValidationProvider
                    name="Quiz Type"
                    rules="required"
                    v-slot="{ errors }">
                    <select class="form-control" v-model="vmQuizFormData.app_type" disabled>
                    <option v-for="(Exam_type, index) in QuizType" :key="(index+1)" :value="index" >
                      {{ index }}
                    </option>
                    </select>
                    <span class="text-danger"> {{ errors[0] }} </span>
                  </ValidationProvider>
                  -->
                </div>
                <div class="col-md-12 mb-3">
                  <label for="validationexam_description">
                    {{ cvExamDescriptionLabel }}</label>
                    <ValidationProvider
                    name="Quiz Description"
                    rules="required"
                    v-slot="{ errors }">
                  <vue-editor v-model.trim="vmQuizFormData.app_description"></vue-editor>
                  <span class="text-danger"> {{ errors[0] }} </span>
                  </ValidationProvider>
                </div>
                <!-- App Instruction -->
                <div class="col-md-12 mb-3">
                  <label for="validationapp_instruction">
                    {{ cvAppInstructionLabel }}</label>
                  <vue-editor v-model.trim="vmQuizFormData.app_instruction"></vue-editor>
                </div><!-- App Instruction -->
                <!-- App Direction -->
                <div class="col-md-12 mb-3">
                  <label for="validationapp_direction">
                    {{ cvAppDirectionLabel }}</label>
                  <vue-editor v-model.trim="vmQuizFormData.app_direction"></vue-editor>
                </div><!-- App Direction -->
                <div class="col-md-12 mb-3">
                <label for="validationexam_category">{{ cvExamCategoryLabel }}</label><br/>
                <multiselect
                  v-model="exam_category_option_update"
                  :options="categoryNames"
                  :multiple="false"
                  :taggable="true"
                  placeholder="Select or add a category"
                  @tag="addNewCategory"
                  >
                  </multiselect>
                </div>

                <!-- IS this GIDEPlus Quiz -->
                <div class="col-md-12 mb-3">
                  <label for="validationexam_date">{{ cvExamIsGidePlusLabel }}</label>
                    <ValidationProvider name="Is this is a GidePlus Quiz ?" rules="required" v-slot="{ errors }">
                      <multiselect v-model="app_is_gideplus" :options="cvExamIsGidePlusOptions" track-by="name" label="name"></multiselect>
                      <span class="text-danger"> {{ errors[0] }} </span>
                    </ValidationProvider>
                </div><!-- IS this GIDEPlus Quiz -->

                <div class="col-md-12 mb-3" v-if="vmQuizFormData.app_type == QuizType.COMPETITION">
                  <label for="validationexam_date">
                    {{ cvExamDateLabel }}</label>
                      <datetime
                      type="datetime"
                      v-model="vmQuizFormData.exam_date"
                      input-class="gide_datetime_input form-control"
                      placeholder="Date month year at time"
                      class="datetime-theme-primary"
                      :format="{ year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: '2-digit'}"
                      :phrases="{ok: 'Continue', cancel: 'Exit'}"
                      :hour-step="1"
                      :minute-step="5"
                      :week-start="7"
                      use12-hour
                      auto
                      :min-datetime="vmStartDate ? vmStartDate : minStartDate"
                      required>
                      </datetime>
                </div>

                <div class="col-md-12 mb-3">
                  <label for="validationexam_date">
                    {{ cvExamDurationLabel }}</label>
                    <ValidationProvider
                      name="Quiz Duration (in seconds)"
                      rules="required"
                      v-slot="{ errors }">
                    <input v-model="vmQuizFormData.app_duration" type="number" class="form-control" required />
                    <span class="text-danger"> {{ errors[0] }} </span>
                    </ValidationProvider>
                </div>

                <div class="col-md-12 mb-3" v-if="vmQuizFormData.app_type == QuizType?.TEST_PREP">
                  <label for="validationexam_date">{{ cvQuestionBatchNo }} </label>
                  <input v-model="vmQuizFormData.batch_no" type="number" class="form-control" required />
                </div>

                <!-- Per question marks mcq -->
                <div class="col-md-6 mb-3">
                  <label for="app_per_q_marks_mcq">{{ cvMarksPerMCQ }}</label>
                  <ValidationProvider name="M arks for each mcq question" rules="required" v-slot="{ errors }">
                    <input @input="appTotalQuestionScoreSet" id="app_per_q_marks_mcq" v-model="vmQuizFormData.app_per_q_marks_mcq" type="number" class="form-control" required />
                    <span class="text-danger"> {{ errors[0] }} </span>
                  </ValidationProvider>
                </div><!-- Per question marks mcq -->

                <!-- Per question marks frq -->
                <div class="col-md-6 mb-3">
                  <label for="app_per_q_marks_frq">{{ cvMarksPerFRQ }}</label>
                  <ValidationProvider name="Marks for each frq question" rules="required" v-slot="{ errors }">
                    <input @input="appTotalQuestionScoreSet" id="app_per_q_marks_frq" v-model="vmQuizFormData.app_per_q_marks_frq" type="number" class="form-control" required />
                    <span class="text-danger"> {{ errors[0] }} </span>
                  </ValidationProvider>
                </div><!-- Per question marks frq -->

                <!-- total mcq questions in app -->
                <div class="col-md-6 mb-3">
                  <label for="app_total_questions_mcq">{{ cvMCQCount }}</label>
                  <ValidationProvider name="MCQ Count" rules="required" v-slot="{ errors }">
                    <input @input="appTotalQuestionScoreSet" id="app_total_questions_mcq" v-model="vmQuizFormData.app_total_questions_mcq" type="number" class="form-control" required />
                    <span class="text-danger"> {{ errors[0] }} </span>
                  </ValidationProvider>
                </div><!-- total mcq questions in app -->

                <!-- total frq questions in app -->
                <div class="col-md-6 mb-3">
                  <label for="app_total_questions_frq">{{ cvFRQCount }}</label>
                  <ValidationProvider name="FRQ Count" rules="required" v-slot="{ errors }">
                    <input @input="appTotalQuestionScoreSet" id="app_total_questions_mcq" v-model="vmQuizFormData.app_total_questions_frq" type="number" class="form-control" required />
                    <span class="text-danger"> {{ errors[0] }} </span>
                  </ValidationProvider>
                </div><!-- total frq questions in app -->

                <div class="col-md-6 mb-3">
                  <label for="validationexam_date">
                    {{ cvExamTotalQuestion }}</label>
                    <ValidationProvider
                    name="Set Total Questions in this Quiz"
                    rules="required"
                    v-slot="{ errors }">
                    <input v-model="vmQuizFormData.app_total_questions" type="number" class="form-control" required />
                    <span class="text-danger"> {{ errors[0] }} </span>
                    </ValidationProvider>
                </div>

                <div class="col-md-6 mb-3">
                  <label for="validationexam_date">
                    {{ cvExamTotalScore }}</label>
                    <ValidationProvider
                    name="Set Quiz Total Score"
                    rules="required"
                    v-slot="{ errors }">
                    <input v-model="vmQuizFormData.app_total_score" type="number" class="form-control" required />
                    <span class="text-danger"> {{ errors[0] }} </span>
                  </ValidationProvider>
                </div>

                <div class="col-md-12 mb-3" gide_inline_textorcheckbox>
                  <label for="validationexam_date">
                    {{ cvExamPassingScore }}</label>
                    <ValidationProvider
                    name="Set Quiz Passing Score"
                    rules="required"
                    v-slot="{ errors }">
                    <input v-model="vmQuizFormData.app_passing_score" type="text" class="form-control" required />
                    <span class="text-danger"> {{ errors[0] }} </span>
                    </ValidationProvider>
                </div>

                <div class="col-md-12 mb-3">
                  <label for="validationquestion">
                    {{ cvDifficultyLabel }}</label>
                    <select class="form-control" v-model="vmQuizFormData.difficulty">
                      <option value="easy">Easy</option>
                      <option value="medium">Medium</option>
                      <option value="hard">Hard</option>
                    </select>
                </div>

                <!-- Reference Sheet Image: shown in the Reference popup on the quiz screen (hidden on prod with the new quiz screen) -->
                <div v-if="VUE_APP_ENV != 'prod'" class="col-md-12 mb-3">
                  <label for="app_ref_sheet_image">{{ cvAppRefSheetImage }}</label>
                  <select id="app_ref_sheet_image" class="form-control" v-model="vmQuizFormData.app_ref_sheet_image">
                    <option v-for="(refSheetUrl, refSheetKey) in cvRefSheetImgObj" :key="refSheetKey" :value="refSheetUrl">{{ refSheetKey }}</option>
                  </select>
                </div><!-- Reference Sheet Image -->

                <div class="col-12 col-md-6 col-lg-4 mb-3 gide_inline_textorcheckbox">
                  <ValidationProvider rules="required" v-slot="{ errors }">
                    <input id="is_ques_shuffled" v-model="vmQuizFormData.is_ques_shuffled" type="checkbox" class="form-control" required />
                    <span class="text-danger"> {{ errors[0] }} </span>
                  </ValidationProvider>
                  <label class="lable ml-2" for="is_ques_shuffled">{{ cvShuffle }}</label>
                </div>

                <div class="col-12 col-md-6 col-lg-4 mb-3 gide_inline_textorcheckbox">
                  <ValidationProvider rules="required" v-slot="{ errors }">
                    <input id="has_timer" v-model="vmQuizFormData.has_timer" type="checkbox" class="form-control" required />
                    <span class="text-danger"> {{ errors[0] }} </span>
                  </ValidationProvider>
                  <label class="lable ml-2" for="has_timer">{{ cvConfigureTimer }}</label>
                </div>

                <!-- Allow quiz Resume -->
                <div class="col-12 col-md-6 col-lg-4 mb-3 gide_inline_textorcheckbox">
                  <ValidationProvider rules="required" v-slot="{ errors }">
                    <input id="allow_quiz_resume" v-model="vmQuizFormData.allow_quiz_resume" type="checkbox" class="form-control" required />
                    <span class="text-danger"> {{ errors[0] }} </span>
                  </ValidationProvider>
                  <label title="This flag indicates, if the quiz in-progress should resume from the last state after browser crash or start a new quiz session" class="lable ml-2" for="allow_quiz_resume">{{ cvAllowQuizResume }}</label>
                </div><!-- Allow quiz Resume -->

                <div class="col-12 col-md-6 col-lg-4 mb-3 gide_inline_textorcheckbox">
                  <!-- Show Leaderboard -->
                  <ValidationProvider rules="required" v-slot="{ errors }">
                    <input id="show_leaderboard" v-model="vmQuizFormData.show_leaderboard" type="checkbox" class="form-control" required />
                    <span class="text-danger"> {{ errors[0] }} </span>
                  </ValidationProvider>
                  <label class="lable ml-2" for="show_leaderboard">{{ cvShowLeaderboard }}</label>
                </div>

                <div class="col-12 col-md-6 col-lg-4 mb-3 gide_inline_textorcheckbox">
                  <!-- Show Play Again -->
                  <ValidationProvider rules="required" v-slot="{ errors }">
                    <input id="show_playagain" v-model="vmQuizFormData.show_playagain" type="checkbox" class="form-control" required />
                    <span class="text-danger"> {{ errors[0] }} </span>
                  </ValidationProvider>
                  <label class="lable ml-2" for="show_playagain">{{ cvShowPlayAgain }}</label>
                </div>

                <!-- Show rank -->
                <div class="col-12 col-md-6 col-lg-4 mb-3 gide_inline_textorcheckbox">
                  <ValidationProvider rules="required" v-slot="{ errors }">
                    <input id="show_rank" v-model="vmQuizFormData.show_rank" type="checkbox" class="form-control" required />
                    <span class="text-danger"> {{ errors[0] }} </span>
                  </ValidationProvider>
                  <label class="lable ml-2" for="show_rank">{{ cvShowRank }}</label>
                </div>
                <!-- Show Analysis -->
                <div class="col-12 col-md-6 col-lg-4 mb-3 gide_inline_textorcheckbox">
                  <ValidationProvider rules="required" v-slot="{ errors }">
                    <input id="show_analysis" v-model="vmQuizFormData.show_analysis" type="checkbox" class="form-control" required />
                    <span class="text-danger"> {{ errors[0] }} </span>
                  </ValidationProvider>
                  <label class="lable ml-2" for="show_analysis">{{ cvShowAnalysis }}</label>
                </div><!-- Show Analysis -->
                <!-- Is Question Shortcut -->
                <div class="col-12 col-md-6 col-lg-4 mb-3 gide_inline_textorcheckbox">
                  <ValidationProvider rules="required" v-slot="{ errors }">
                    <input id="is_question_shortcut" v-model="vmQuizFormData.is_question_shortcut" type="checkbox" class="form-control" required />
                    <span class="text-danger"> {{ errors[0] }} </span>
                  </ValidationProvider>
                  <label class="lable ml-2" for="is_question_shortcut">{{ cvIsQuestionShortcut }}</label>
                </div><!-- Is Question Shortcut -->
                <!-- Allow Generates Ans Explanation -->
                <div class="col-12 col-md-6 col-lg-4 mb-3 gide_inline_textorcheckbox">
                  <ValidationProvider rules="required" v-slot="{ errors }">
                    <input id="allow_auto_ans_exp_gen" v-model.trim="vmQuizFormData.allow_auto_ans_exp_gen" type="checkbox" class="form-control" required />
                    <span class="text-danger"> {{ errors[0] }} </span>
                  </ValidationProvider>
                  <label class="lable ml-2" for="allow_auto_ans_exp_gen">{{ cvAllowAutoAnsExpGen }}</label>
                </div><!-- Allow Generates Ans Explanation -->
                <div class="col-12 col-md-6 col-lg-4 mb-3 gide_inline_textorcheckbox">
                  <!-- Show Results -->
                  <ValidationProvider rules="required" v-slot="{ errors }">
                    <input id="show_results" v-model="vmQuizFormData.show_results" type="checkbox" class="form-control" required />
                    <span class="text-danger"> {{ errors[0] }} </span>
                  </ValidationProvider>
                  <label class="lable ml-2" for="show_results">{{ cvShowResults}}</label>
                </div>
                <!-- Redirect to thank you page -->
                <div class="col-12 col-md-6 col-lg-4 mb-3 gide_inline_textorcheckbox">
                  <ValidationProvider rules="required" v-slot="{ errors }">
                    <input id="redirect_to_thankyou_page" v-model="vmQuizFormData.redirect_to_thankyou_page" type="checkbox" class="form-control" required />
                    <span class="text-danger"> {{ errors[0] }} </span>
                  </ValidationProvider>
                  <label class="lable ml-2" for="redirect_to_thankyou_page">{{ cvRedirectToThankyouPage}}</label>
                </div><!-- Redirect to thank you page -->

                <!-- Quiz ai tutor -->
                 <div class="col-12 col-md-6 col-lg-4 mb-3 gide_inline_textorcheckbox">
                  <ValidationProvider rules="required" v-slot="{ errors }">
                    <input id="is_ai_tutor" v-model="vmQuizFormData.is_ai_tutor" type="checkbox" class="form-control" required />
                    <span class="text-danger"> {{ errors[0] }} </span>
                  </ValidationProvider>
                  <label class="lable ml-2" for="is_ai_tutor">{{ cvIsAppTutor }}</label>
                </div><!-- Quiz ai tutor -->

                <!-- Split View: checked = Split Screen, unchecked = Full Screen (hidden on prod until the layout switch goes live) -->
                <div v-if="VUE_APP_ENV != 'prod'" class="col-12 mb-3 view-type-row">
                  <div class="gide_inline_textorcheckbox">
                    <ValidationProvider rules="required" v-slot="{ errors }">
                      <input id="is_split_view" v-model="vmQuizFormData.is_split_view" type="checkbox" class="form-control" required />
                      <span class="text-danger"> {{ errors[0] }} </span>
                    </ValidationProvider>
                    <label class="lable ml-2" for="is_split_view">{{ cvIsSplitView }}</label>
                  </div>
                  <span class="view-type-previews">
                    <template v-for="preview in cvViewTypePreviews">
                      <span v-if="!vmViewTypePreviewErr[preview.key]" :key="preview.key" class="view-type-preview" :title="`Click to preview ${preview.label}`" @click="vmViewTypePreview = preview">
                        <img :src="preview.img" :class="['view-type-thumb', { active: (preview.key === 'horizontal') === !!vmQuizFormData.is_split_view }]" :alt="`${preview.label} Preview`" @error="$set(vmViewTypePreviewErr, preview.key, true)" />
                        <small>{{ preview.label }}</small>
                      </span>
                    </template>
                  </span>
                </div><!-- Split View -->

                <!-- GIDE Brand Color: checked = GIDE colors, unchecked = Bluebook colors on the quiz screen (hidden on prod with the new quiz screen) -->
                <div v-if="VUE_APP_ENV != 'prod'" class="col-12 col-md-6 col-lg-4 mb-3 gide_inline_textorcheckbox">
                  <input id="is_gide_brand_color" v-model="vmQuizFormData.is_gide_brand_color" type="checkbox" class="form-control" />
                  <label class="lable ml-2" for="is_gide_brand_color">{{ cvIsGideBrandColor }}</label>
                </div><!-- GIDE Brand Color -->

                <!-- View Type Preview Modal -->
                <b-modal :visible="!!vmViewTypePreview" size="xl" centered hide-footer :title="vmViewTypePreview ? vmViewTypePreview.label : ''" @hidden="vmViewTypePreview = null">
                  <img v-if="vmViewTypePreview" :src="vmViewTypePreview.img" class="w-100" :alt="`${vmViewTypePreview.label} Preview`" />
                </b-modal><!-- View Type Preview Modal -->

                <!-- Redirect URL -->
                <div class="col-md-12 mb-3">
                  <label for="redirect_link">{{ cvRedirectLinkLabel }}</label>
                  <input id="redirect_link" v-model="vmQuizFormData.app_redirect_to_thankyou_page_to_other" type="text" class="form-control" required />
                  <span class="primary-color"><small><i>* With this input you can redirect to a link after thankyou page after 3 seconds</i></small></span>
                </div><!-- Redirect URL -->

                <div class="col-12 col-sm-6 col-md-6 col-lg-4 mb-2 gide_inline_textorcheckbox" v-if="vmQuizFormData.app_type == QuizType.COMPETITION">
                  <label class="lable" for="validationexam_name">
                    {{ cvExamIsPaid }}</label>
                  <ValidationProvider
                    name="Is this a Paid Quiz ?"
                    rules="required"
                    v-slot="{ errors }">
                  <input v-model="app_is_paid" type="checkbox" class="form-control" required />
                  <span class="text-danger"> {{ errors[0] }} </span>
                  </ValidationProvider><br>
                </div>
                <!-- <div class="col-12 col-sm-6 col-md-6 col-lg-4 mb-2 gide_inline_textorcheckbox">
                  <label class="lable" for="validationexam_date">
                    {{ cvExamIsOneTime }}</label>
                  <ValidationProvider
                    name="Is this a One-Time Quiz ?"
                    rules="required"
                    v-slot="{ errors }">
                  <input v-model="app_is_one_time" type="checkbox" class="form-control" required />
                  <span class="text-danger"> {{ errors[0] }} </span>
                  </ValidationProvider><br>
                </div> -->

                <div class="col-12 mb-3 mt-4">
                  <div class="mb-2"><b>The below configuration is required for GIDE.AI to find the Category of the questions and validate the quality of the Questions to be uploaded</b></div>
                  <label class="" for="app_qbk_category_list">
                    {{ cvAppQuestionTypeCategoryList }}<br>
                    <small>(Example: Data Analysis and Problem Solving, Advanced Math, Geometry and Trigonometry, Algebra, Mathematics)</small>
                  </label>
                  <ValidationProvider
                    name="QbkCategoryList"
                    rules="required"
                    v-slot="{ errors }">
                    <textarea class="textarea form-control" v-model="vmQuizFormData.app_qbk_category_list" required></textarea>
                    <span class="text-danger"> {{ errors[0] }} </span>
                  </ValidationProvider>
                  <small class="information-color">* Copy the comma separated list and replace the MACRO {APP_QBK_CATEGORY_LIST} in the textbox below.</small>
                </div>
                <div class="col-12 mb-3" :key="vmQuizFormData.app_prompt">
                  <label class="" for="app_prompt">{{ cvAppPrompt }}</label>
                  <ValidationProvider
                    name="AppPrompt"
                    rules="required"
                    v-slot="{ errors }">
                    <textarea class="textarea form-control" v-model="vmQuizFormData.app_prompt" required></textarea>
                    <span class="text-danger"> {{ errors[0] }} </span>
                  </ValidationProvider>
                  <small class="information-color">* Replace the known MACROs (Ex. {QUIZ_EXAM_NAME}) or change the prompt as per your requirements</small>
                </div>
              </div>
              <div>
                <div class="col-7">
                  <button type="button" class="btn btn-primary" @click="appEdit()">
                    {{ cvSubmitBtn }}
                  </button>
                </div>
                <div class="col-5 spinner_add">
                  <button  v-if="cvLoadingStatus" type="button" class="btn btn-primary float-right" :disabled="cvLoadingStatus">
                    <b-spinner label="Spinning"></b-spinner>
                  </button>
                </div>
              </div>
            </form>
          </template>
        </iq-card>
      </b-col>
    </b-row>
    <CropImage :prop-crop-image-dialog-open="propCropImageDialogOpen" :propCropModalSize="propCropDialogSize" :prop-stencil-size="propStencilSize" :propSrc="fileSrc" @emitCroppedImg="getCroppedImg" @emitCroppedImgFile="emitCroppedImgFile" />
    <b-toast v-model="showToast" name="Toast" :variant="toastVariant" :title="toastTitle">
      <div v-html="toastMsg"></div>
    </b-toast>
  </b-container>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css">
</style>
<script>
import { Apps } from "../../../FackApi/api/apps.js"
import ApiResponse from "../../../Utils/apiResponse.js"
import { ValidationProvider } from "vee-validate"
import QuizType from "../../../FackApi/json/QuizType.js"
import { Datetime } from "vue-datetime"
import CropImage from "../../../components/cropImage.vue"
import { VueEditor } from "vue2-editor"
import Multiselect from "vue-multiselect"
import moment from "moment"
import { socialvue } from "../../../config/pluginInit.js"
import userPermission from "../../../Utils/user_permission.js"
import TestSeriesConfigJson from "../../../FackApi/json/TestSeries.json"
import "vue-datetime/dist/vue-datetime.css"

export default {
  name: "AppEdit",
  components: {
    VueEditor,
    ValidationProvider,
    Datetime,
    CropImage,
    Multiselect
  },
  props: {
    propOpenedInModal: {
      type: Boolean,
      default: false
    },
    propQuizObj: {
      type: Object,
      default: function () {
        return {
          "app_name": "",
          "app_description": "",
          "app_category": "",
          "app_date_ts": ""
        }
      }
    }
  },
  data () {
    return {
      apiName: "app_edit",
      cvCardTitle: "Edit App",
      cvSubmitBtn: "Save",
      cvExamNameLabel: "App Name",
      cvAliasNamelabel: "App Name Alias",
      cvExamTypeLabel: "App Type",
      cvExamDescriptionLabel: "App Description",
      cvAppInstructionLabel: "App Instruction",
      cvAppDirectionLabel: "App Direction",
      cvExamCategoryLabel: "App Category",
      cvExamIsGidePlusLabel: "App Is Gideplus ?",
      cvExamDateLabel: "App Date",
      cvExamDurationLabel: "App Duration(in second))",
      cvExamTotalQuestion: "Ques Per Quiz",
      cvQuestionBatchNo: "Batch No. the question belongs to",
      cvExamTotalScore: "App Total Score (100, 50 ,20)",
      cvExamPassingScore: "App Passing Score",
      cvShuffle: "Show questions shuffled ?",
      cvShowAnalysis: "Show Analysis",
      cvIsQuestionShortcut: "Show Ques. No. Dropdown",
      cvConfigureTimer: "Show timer for this App ?",
      cvAllowQuizResume: "Reload App Session",
      cvShowLeaderboard: "Show Leaderboard",
      cvShowPlayAgain: "Show Play Again Button",
      cvShowRank: "Show Rank",
      cvRedirectToThankyouPage: "Redirect to Thank You Page",
      cvShowResults: "Show Results",
      cvExamIsPaid: "App Is Paid ?",
      cvAllowAutoAnsExpGen: "Allow AI to Generate Answer Explanation",
      // cvExamIsOneTime: "Quiz Is One Time",
      cvExamImage: "App Image",
      cvDifficultyLabel: "App/Quiz Difficulty",
      cvLoadingStatus: false,
      toastMsg: null,
      toastVariant: "default",
      toastTitle: "App",
      QuizType: QuizType,
      categoryNames: [],
      getSelectedAppObject: null,
      vmQuizFormData: {
        chain_to: null,
        chained_app_id: null,
        chained_app_name: null,
        exam_category_option: null,
        textarea: ""
      },
      vmqbkExamCategoryList: " ",
      vmStartDate: null,
      minStartDate: null,
      showToast: false,
      cvPBACoverPic: "Edit App Picture",
      vmCoverPic: "",
      propCropImageDialogOpen: false,
      propCropDialogSize: "md",
      propStencilSize: null,
      fileSrc: "",
      cvImageExtensionErrorMsg: " Only jpeg, webp and png is supported.",
      cvImageSizeErrorMsg: " Image size must be less than 300 kb.",
      updateImageType: null,
      vmProfilePic: "",
      app_id: "",
      cvCoverPicLoading: false,
      cvCoverPicError: false,
      isPhotoUploaded: false,
      cvRedirectLinkLabel: "Redirect After Thankyou",
      cvIsAppTutor: "Enable AI Tutor?",
      cvIsSplitView: "Split View (Question & Options Side by Side)",
      cvIsGideBrandColor: "GIDE Brand Color on Quiz Screen",
      cvAppRefSheetImage: "Reference Sheet",
      cvRefSheetImgObj: TestSeriesConfigJson.REF_SHEET_IMG_OBJ,
      VUE_APP_ENV: process.env.VUE_APP_ENV,
      cvViewTypePreviews: [
        { key: "horizontal", label: "Split Screen", img: "https://gide-assets.s3.us-east-1.amazonaws.com/quiz-horizontal-view.png" },
        { key: "vertical", label: "Full Screen", img: "https://gide-assets.s3.us-east-1.amazonaws.com/quiz-vertical-view.png" }
      ],
      vmViewTypePreview: null,
      vmViewTypePreviewErr: {},
      cvExamIsGidePlusOptions: [
        {
          name: "For All"
        },
        {
          name: "Gide+"
        }
      ],
      chainableApps: [],
      app_is_gideplus: "",
      app_is_one_time: false,
      app_is_paid: false,
      imageSize: "Size  1080 * 566",
      updateCategoryCount: 0,
      cvAppQuestionTypeCategoryList: "App Questions Category List",
      cvAppPrompt: "Prompt to validate the question and determine the exact category and difficulty level of the questions",
      appPrompt: "For this {QUIZ_EXAM_NAME} evaluate and analyse the question to find the following - difficulty level as difficulty from the option: easy, medium, difficult, find skills tested by the question as skill, find the single most best matching category for this question as qbk_category from the following options: {APP_QBK_CATEGORY_LIST}. Also find if the question meets the standards of this exam/quiz as is_standard with boolean response along with the reason as is_standard_reason. All the response should be in JSON format, for the following question: {QUESTION} on {QUIZ_NAME}",
      exam_category_option_update: "",
      cvMarksPerMCQ: "Marks Per MCQ",
      cvMarksPerFRQ: "Marks Per FRQ",
      cvMCQCount: "Total MCQ Questions",
      cvFRQCount: "Total FRQ Questions"
    }
  },
  computed: {
    userData () {
      return { ...this.$store.getters["User/userData"] }
    }
  },
  beforeMount () {
    // Auth Access for Current User Role
    if (!userPermission(this, this.userData, this.apiName)) {
      this.$router.back()
    }
  },
  mounted () {
    this.QuizType = this.QuizType()
    socialvue.index()
    this.QuizType = QuizType(this.userData.user_role)
    this.appView()
    this.appCategoryDistinct()
    this.getAppsOfType()
  },
  methods: {
    /**
     * addNewCategory
     */
    addNewCategory (category) {
      this.categoryNames.push(category)
      this.vmQuizFormData.exam_category_option = category
      this.exam_category_option_update = category
    },
    /**
     * onSelectApp
     */
    onSelectApp (selectedApp) {
      this.vmQuizFormData.chain_to = selectedApp ? selectedApp.app_id : null
      this.getSelectedAppObject = this.chainableApps.find(app => app.app_id === this.vmQuizFormData.chain_to) || null
    },
    /**
     * validate
     */
    validate () {
      try {
        for (let index in this.vmQuizFormData) {
          if (!this.vmQuizFormData[index]) {
            this.toastMsg = "Missing " + index.split("_").join(" ")
            this.toastVariant = "danger"
            this.showToast = true
            return false
          }
        }
        return true
      }
      catch (err) {
        console.error("Exception occurred at validate() and Exception:", err.message)
        return null
      }
    },
    /**
     * appView
     */
    async appView () {
      try {
        if (this.propOpenedInModal) {
          this.vmQuizFormData = this.propQuizObj
          // Quiz Images
          if (this.vmQuizFormData.app_image) {
            this.vmCoverPic = this.vmQuizFormData.app_image
          }

          this.exam_category_option_update = this.vmQuizFormData.app_category
          this.vmQuizFormData.exam_date = moment(new Date().setTime(this.vmQuizFormData.app_date_ts * 1000)).format()
          this.app_is_gideplus = this.vmQuizFormData.app_is_gideplus == 1 ? { name: "Gide+" } : { name: "For All" }
          /** eslint disable-next-line **/
          this.app_is_one_time = this.vmQuizFormData.app_is_one_time == 1 ? true : false // eslint-disable-line
          this.app_is_paid = this.vmQuizFormData.app_is_paid == 1 ? true : false // eslint-disable-line
        }
        else {
          let quizId = this.$route.params.app_id
          let quizViewResp = await Apps.appView(this, quizId)

          if (quizViewResp && quizViewResp.resp_status) {
            this.vmQuizFormData = quizViewResp.resp_data.data
            this.exam_category_option_update = quizViewResp.resp_data.data.app_category

            this.vmQuizFormData.exam_date = moment(new Date().setTime(this.vmQuizFormData.app_date_ts * 1000)).format()
            this.app_is_gideplus = this.vmQuizFormData.app_is_gideplus == 1 ? { name: "Gide+" } : { name: "For All" }
            /** eslint disable-next-line **/
            this.app_is_one_time = this.vmQuizFormData.app_is_one_time == 1 ? true : false // eslint-disable-line
            this.app_is_paid = this.vmQuizFormData.app_is_paid == 1 ? true : false // eslint-disable-line
            this.vmQuizFormData.app_type = quizViewResp.resp_data.data.app_type
          }
          // Quiz Images
          if (this.vmQuizFormData.app_image) {
            this.vmCoverPic = this.vmQuizFormData.app_image
          }
        }

        // Create the prompt
        this.appPrompt = this.vmQuizFormData.app_name_alias ? this.appPrompt.replace("{QUIZ_NAME}", this.vmQuizFormData.app_name_alias) : this.appPrompt
        this.appPrompt = this.vmQuizFormData.app_qbk_category_list ? this.appPrompt.replace("{APP_QBK_CATEGORY_LIST}", this.vmQuizFormData.app_qbk_category_list) : this.appPrompt
        this.vmQuizFormData.app_prompt = this.vmQuizFormData.app_prompt ? this.vmQuizFormData.app_prompt : this.appPrompt
      }
      catch (err) {
        console.error("Exception occurred at appView() and Exception:", err.message)
      }
    },
    /**
     * appEdit
     */
    async appEdit () {
      try {
        this.cvLoadingStatus = true
        this.vmQuizFormData.app_date_ts = this.vmQuizFormData.exam_date ? (moment(this.vmQuizFormData.exam_date).valueOf() / 1000) : 0
        this.vmQuizFormData.app_is_gideplus = this.app_is_gideplus.name === "Gide+" ? 1 : 0
        this.vmQuizFormData.app_is_one_time = this.app_is_one_time === true ? 1 : 0
        this.vmQuizFormData.app_is_paid = this.app_is_paid === true ? 1 : 0
        this.vmQuizFormData.allow_auto_ans_exp_gen = this.vmQuizFormData.allow_auto_ans_exp_gen === true ? 1 : 0

        // If app instruction has only spaces/empty tags then clear it so the quiz shows the app description
        const appInstruction = this.vmQuizFormData.app_instruction || ""
        if (!appInstruction.replace(/<[^>]*>|&nbsp;/g, "").trim()) {
          this.vmQuizFormData.app_instruction = ""
        }

        // If app direction has only spaces/empty tags then clear it so the quiz shows the default directions
        const appDirection = this.vmQuizFormData.app_direction || ""
        if (!appDirection.replace(/<[^>]*>|&nbsp;/g, "").trim()) {
          this.vmQuizFormData.app_direction = ""
        }

        if (this.vmQuizFormData.exam_category_option_update !== "AddNew") {
          this.vmQuizFormData.app_category = this.vmQuizFormData.exam_category_option_update
        }
        if (this.exam_category_option_update) {
          this.vmQuizFormData.app_category = this.exam_category_option_update
        }
        let quizAddResp = await Apps.appEdit(this, this.vmQuizFormData)
        await ApiResponse.responseMessageDisplay(this, quizAddResp)

        if (quizAddResp && !quizAddResp.resp_status) {
          return false
        }

        if (this.isPhotoUploaded) {
          let imageAddResp = await this.imageAdd(this.vmQuizFormData.app_id)
          if (imageAddResp && imageAddResp.resp_status) {
            quizAddResp.resp_data.app_image = imageAddResp.resp_data[0].image
          }
          this.isPhotoUploaded = false
        }

        //  Emit if opened in Modal
        if (this.propOpenedInModal) {
          this.$emit("emitCloseQuizEditModal", this.vmQuizFormData)
        }
        else {
          this.appView()
        }
      }
      catch (err) {
        console.error("Exception occurred at appEdit() and Exception:", err.message)
      }
      finally {
        this.cvLoadingStatus = false
      }
    },
    /**
     * appCategoryDistinct
     */
    async appCategoryDistinct () {
      try {
        const resp = await Apps.appCategoryDistinct(this)
        this.categoryNames = resp.resp_data.data.map(d => d.app_category)
      }
      catch (err) {
        console.error("Exception occurred at appCategoryDistinct() and Exception:", err.message)
      }
    },
    /**
     * appTotalQuestionScoreSet
     * Sets the app_total_question and app_total_score form fields as app_per_q_marks_mcq, app_per_q_marks_frq, app_total_questions_mcq, app_total_questions_frq changes
     */
    appTotalQuestionScoreSet () {
      const vmQuizFormDataCopy = { ...this.vmQuizFormData }
      vmQuizFormDataCopy.app_total_questions = Number(this.vmQuizFormData.app_total_questions_mcq) + Number(this.vmQuizFormData.app_total_questions_frq)
      vmQuizFormDataCopy.app_total_score = (Number(this.vmQuizFormData.app_per_q_marks_mcq) * Number(this.vmQuizFormData.app_total_questions_mcq)) + (Number(this.vmQuizFormData.app_per_q_marks_frq) * Number(this.vmQuizFormData.app_total_questions_frq))

      this.vmQuizFormData = vmQuizFormDataCopy
    },
    /**
     * getAppsOfType
     * event_state: 0 - Published
     * event_state: 1 - Deleted
     * event_state: 2 - UnPublished
     *
     * removeappfromchain => This option is passed when the user wants to remove the child item in the chain and does not want to add another child item
     */
    async getAppsOfType () {
      const filter = { event_state: "0|2" }
      const appsToBeChained = await Apps.appListConsole(this, filter)
      if (appsToBeChained.resp_status) {
        this.chainableApps = appsToBeChained.resp_data.data
        this.chainableApps = [{ app_name: "Remove app from chain", app_id: "removeappfromchain" }, ...this.chainableApps]
      }
    },
    /**
     * openImageDialog
     *
     */
    openImageDialog (e, imageType) {
      this.isPhotoUploaded = true
      this.updateImageType = imageType
      if (e.target.files.length > 0) {
        this.fileSrc = e.target.files[0]
      }
      let input = e.target
      if (input.files.length > 0 && input.files[0]) {
        let image = input.files[0]
        let allowedExtension = [ "image/png", "image/jpg", "image/jpeg", "image/webp" ]
        let maxSize = 300 * 1024 // 300 KB in bytes
        if (!allowedExtension.includes(image.type)) {
          if (imageType === "Profile Pic") {
            this.toastMsg = this.cvImageExtensionErrorMsg
            this.showToast = true
          }
          else {
            this.toastMsg = this.cvImageExtensionErrorMsg
            this.showToast = true
          }
          return false
        }
        else if (image.size > maxSize) {
          // validate image size
          if (imageType === "Profile Pic") {
            this.toastMsg = this.cvImageSizeErrorMsg
            this.showToast = true
          }
          else {
            this.toastMsg = this.cvImageSizeErrorMsg
            this.toastVariant = "danger"
            this.showToast = true
          }
          return false
        }
        this.propStencilSize = {
          "width": 540,
          "height": 283
        }
        this.propCropDialogSize = "md"
        this.propCropImageDialogOpen = Math.random()
      }
    },
    /**
     * getCroppedImg
     */
    getCroppedImg (img) {
      if (this.updateImageType === "Profile Pic") {
        this.vmProfilePic = img
      }
      else {
        this.vmCoverPic = img
      }
    },
    /**
     * emitCroppedImgFile
     */
    emitCroppedImgFile (imgObj) {
      let img = imgObj.imgFile
      let orgImg = imgObj.orgImage
      let imageType = this.updateImageType
      this.onChangeProfileImage(img, imageType)
      this.vmPBACoverPicImage = Object.assign({}, this.initImageData())
      this.vmPBACoverPicImage.image = {
        "img": img,
        "name": orgImg.name
      }
      this.vmPBACoverPicImage.image_type = "cover_pic"
    },
    /**
     * onChangeProfileImage
     */
    onChangeProfileImage (e, imageType) {
      try {
        const reader = new FileReader()
        reader.onload = async (e) => {
          if (imageType === "Profile Pic") {
            this.vmProfilePic = await reader.result
          }
          else {
            this.vmCoverPic = await reader.result
          }
        }
        // reader.readAsDataURL(image)
      }
      catch (err) {
        console.error("Exception occurred at onChangeProfilePic() and Exception:", err.message)
      }
    },
    /**
     * initImageData
     */
    initImageData () {
      return {
        image: "",
        image_type: ""
      }
    },
    /**
     * initPBAData
     */
    initPBAData () {
      return {
        question_name: "",
        module_id: ""
      }
    },
    /**
     * imageAdd
     */
    async imageAdd (appId) {
      if (this.cvImageError) {
        return
      }
      try {
        this.cvImageLoadingStatus = true
        let imageObj = {
          "module_name": "APPS",
          "module_id": appId,
          "image": []
        }

        if (this.vmPBACoverPicImage.image) {
          imageObj.image.push(this.vmPBACoverPicImage)
        }

        if (imageObj.image.length < 1) {
          return false
        }

        const imageUpdateResp = await Apps.imageAddToApp(this, imageObj)
        await ApiResponse.responseMessageDisplay(this, imageUpdateResp)
        if (imageUpdateResp && !imageUpdateResp.resp_status) {
          return false
        }

        this.vmPBACoverPicImage = Object.assign({}, this.initPBAData())
        imageObj = {}
        return imageUpdateResp
      }
      catch (err) {
        console.error("Exception occurred at imageAdd() and Exception:", err.message)
        return err
      }
      finally {
        this.cvImageLoadingStatus = false
      }
    },
    /**
     * openChainedAppInNewTab
     */
    openChainedAppInNewTab (chainedAppId) {
      window.open("/quiz_edit/" + chainedAppId)
    },
    /**
     * goToEventDashboard
     */
    goToEventDashboard () {
      this.$router.push("/quiz_list")
    },
    /**
     * quizDetail
    */
    async quizDetail (examId) {
      this.$router.push(`/quiz_detail/${examId}`)
    },
    /**
     * start Quiz
     */
    async startQuiz (examId, pageLayout = null) {
      if (pageLayout) {
        this.$router.push(`/assessment/quiz/${examId}`)
      }
      else {
        this.$router.push(`/question_quiz/${examId}`)
      }
    },
    /**
     * quizBankList
    */
    async quizBankList (examId) {
      this.$router.push(`/quizBank_list/${examId}`)
    }
  }
}
</script>
<style scoped>
  .textarea {
    width: 50%;
    height: 195px !important;
    overflow-y: scroll;
    line-height: 18px !important;
  }
  .card-title{
    font-size: 20px;
    color: #000;
    font-weight: 400;
  }
  .view-type-row {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    column-gap: 24px;
    row-gap: 8px;
  }
  .view-type-previews {
    display: inline-flex;
    gap: 16px;
  }
  .view-type-preview {
    display: inline-flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
    cursor: zoom-in;
  }
  .view-type-preview small {
    font-size: 11px;
    line-height: 1;
    white-space: nowrap;
  }
  .view-type-thumb {
    height: 45px;
    width: 80px;
    object-fit: cover;
    object-position: top;
    border: 1px solid #b5b5b5;
    border-radius: 4px;
  }
  .view-type-preview:hover .view-type-thumb,
  .view-type-thumb.active {
    border-color: var(--iq-primary);
  }
</style>
